import { render, staticRenderFns } from "./driverPriorityDetailsLists.vue?vue&type=template&id=19f6f9b0&scoped=true&"
import script from "./driverPriorityDetailsLists.vue?vue&type=script&lang=js&"
export * from "./driverPriorityDetailsLists.vue?vue&type=script&lang=js&"
import style0 from "./driverPriorityDetailsLists.vue?vue&type=style&index=0&id=19f6f9b0&scoped=true&lang=css&"
import style1 from "./driverPriorityDetailsLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6f9b0",
  null
  
)

export default component.exports